export default {
      id: "close-cross-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#close-cross",
      toString: function () {
        return this.url;
      }
    }